

$(document).on('turbolinks:load', function () {
  "use strict"; // Start of use strict

  // Toggle the side navigation
  $("#sidebarToggle, #sidebarToggleTop").on('click', function(e) {
    $("body").toggleClass("sidebar-toggled");
    $(".sidebar").toggleClass("toggled");
    if ($(".sidebar").hasClass("toggled")) {
      $('.sidebar .collapse').collapse('hide');
    };
  });

  // Close any open menu accordions when window is resized below 768px
  $(window).resize(function() {
    if ($(window).width() < 768) {
      $('.sidebar .collapse').collapse('hide');
    };
  });

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function(e) {
    if ($(window).width() > 768) {
      var e0 = e.originalEvent,
        delta = e0.wheelDelta || -e0.detail;
      this.scrollTop += (delta < 0 ? 1 : -1) * 30;
      e.preventDefault();
    }
  });

  // Scroll to top button appear
  $(document).on('scroll', function() {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $('.scroll-to-top').fadeIn();
    } else {
      $('.scroll-to-top').fadeOut();
    }
  });

  // Smooth scrolling using jQuery easing
  $(document).on('click', 'a.scroll-to-top', function(e) {
    var $anchor = $(this);
    $('html, body').stop().animate({
      scrollTop: ($($anchor.attr('href')).offset().top)
    }, 1000, 'easeInOutExpo');
    e.preventDefault();
  });

  //$(document).on('click','#bc-download-xlsx',function() {
  //setInterval((function() {
  //  location.reload();
  //}
  //location.href = '/lesinternal/deliverydatareg_bulk_create'}
  //), 5000)});
  //  });
});

// Dismiss flash notice


document.addEventListener('click', (event) => {
  if (event.target && event.target.id === 'closeFlashButton') {
    const flashMessage = document.getElementById('flashMessage');
    if (flashMessage) {
      flashMessage.style.display = 'none';
    }
    const flashErrorMessage = document.getElementById('flashErrorMessage');
    if (flashErrorMessage) {
      flashErrorMessage.style.display = 'none';
    }

  }
});

/* loading spinner */
function attachSpinnerToSbmit(elementId, spinnerId) {
  const element = document.getElementById(elementId);
  const spinner = document.getElementById(spinnerId);
  element.addEventListener('submit', (event) => {
    spinner.style.display = 'block';
    setTimeout(() => {
      element.submit();
    }, 2000);
    event.preventDefault();
  });
}

function attachSpinnerToLink(elementId, spinnerId,message) {
  const element = document.getElementById(elementId);
  const spinner = document.getElementById(spinnerId);
  element.addEventListener('click', (event) => {
    event.preventDefault();
    const userConfirmed = confirm(message);
    if (userConfirmed) {
      spinner.style.display = 'block';
      setTimeout(() => {
        window.location.href = element.href;
      }, 2000);
    }
  });
}

function isElementExist(id) {
  const element = document.getElementById(id);
  return element !== null;
}

window.attachSpinnerToSbmit = attachSpinnerToSbmit;
window.attachSpinnerToLink = attachSpinnerToLink;
window.isElementExist = isElementExist;

document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById("resultModal");
  var closeBtn = document.querySelector(".close");

  if (closeBtn) {
    closeBtn.onclick = function() {
      modal.style.display = "none";
    };
  }

  window.onclick = function(event) {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  };
});